(function () {
  var LANDING_PLAN_60 = 691354566995;
  var LANDING_PLAN_30 = 691354501459;
  var REMOVE_SELECTOR = '[data-item-remove], [data-cart-remove], .cart__item__remove, a[href*="/cart/change"]';
  var removing = false;
  var planSyncing = false;
  var originalFetch = window.fetch.bind(window);

  function cartChangeUrl() {
    var route = window.theme && window.theme.routes && window.theme.routes.cart_change_url;
    if (!route) return '/cart/change.js';
    return route.indexOf('.js') === -1 ? route + '.js' : route;
  }

  function isCartChangeRequest(input) {
    var url = '';
    if (typeof input === 'string') url = input;
    else if (input && input.url) url = input.url;
    return url.indexOf('/cart/change') !== -1;
  }

  function keepDrawerOpen(drawer) {
    if (drawer && !drawer.classList.contains('is-open')) drawer.classList.add('is-open');
  }

  function openDrawers() {
    return document.querySelectorAll('cart-drawer.is-open, #cart-drawer.is-open');
  }

  function sellingPlanId(item) {
    var allocation = item && item.selling_plan_allocation;
    var plan = allocation && allocation.selling_plan;
    if (!plan || plan.id == null) return 0;
    var id = Number(plan.id);
    return id > 0 ? id : 0;
  }

  async function reconcileLandingSubscription(cart) {
    if (!cart || !Array.isArray(cart.items) || planSyncing) return cart;

    var landingSubItems = cart.items.filter(function (item) {
      var planId = sellingPlanId(item);
      return planId === LANDING_PLAN_60 || planId === LANDING_PLAN_30;
    });

    var totalQuantity = landingSubItems.reduce(function (sum, item) {
      return sum + (Number(item.quantity) || 0);
    }, 0);

    console.log('[Cart Debug] Remaining landing sub items quantity:', totalQuantity, landingSubItems);

    if (totalQuantity !== 1) return cart;

    var item60 = null;
    for (var i = 0; i < landingSubItems.length; i++) {
      if (sellingPlanId(landingSubItems[i]) === LANDING_PLAN_60) {
        item60 = landingSubItems[i];
        break;
      }
    }

    if (!item60 || !item60.key) return cart;

    console.log('[Cart Debug] Switching line item to 30-day plan:', item60.key);

    planSyncing = true;
    try {
      var changeRes = await originalFetch(cartChangeUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: item60.key,
          selling_plan: LANDING_PLAN_30
        })
      });
      var updatedCart = await changeRes.json();
      if (!changeRes.ok || updatedCart.status || updatedCart.errors || !Array.isArray(updatedCart.items)) return cart;
      return updatedCart;
    } catch (error) {
      console.error('Ошибка при переключении плана подписки:', error);
      return cart;
    } finally {
      planSyncing = false;
    }
  }

  function refreshDrawer(drawer, cart) {
    var cartItems = drawer.querySelector('cart-items');

    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      bubbles: true,
      detail: { cartCount: cart.item_count }
    }));

    drawer.classList.toggle('is-empty', cart.item_count === 0);

    if (cartItems && typeof cartItems.getCart === 'function') {
      cartItems.getCart();
      return;
    }

    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }

  function settleOpenDrawers(cart) {
    openDrawers().forEach(function (drawer) {
      refreshDrawer(drawer, cart);
      keepDrawerOpen(drawer);
      requestAnimationFrame(function () {
        keepDrawerOpen(drawer);
      });
    });
  }

  function restoreOpenDrawer() {
    document.querySelectorAll('cart-drawer, #cart-drawer').forEach(function (drawer) {
      keepDrawerOpen(drawer);
    });
  }

  async function attachFreshSections(cart) {
    if (!cart || !cart.sections || typeof cart.sections !== 'object') return cart;
    var ids = Object.keys(cart.sections);
    if (!ids.length) return cart;

    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var response = await originalFetch(root + '?sections=' + encodeURIComponent(ids.join(',')));
      if (!response.ok) return cart;
      var fresh = await response.json();
      ids.forEach(function (id) {
        if (typeof fresh[id] === 'string') cart.sections[id] = fresh[id];
      });
    } catch (error) {
      console.error('Ошибка при обновлении секции корзины:', error);
    }

    return cart;
  }


  window.fetch = function (input, init) {
    if (!isCartChangeRequest(input) || planSyncing) {
      return originalFetch(input, init);
    }

    var drawerWasOpen = openDrawers().length > 0;

    return originalFetch(input, init).then(async function (response) {
      if (!response.ok) return response;

      var cart;
      try {
        cart = await response.clone().json();
      } catch (error) {
        return response;
      }

      if (!cart || !Array.isArray(cart.items)) return response;

      var next = await reconcileLandingSubscription(cart);
      if (next === cart) return response;

      await attachFreshSections(next);

      if (drawerWasOpen) {
        settleOpenDrawers(next);
        setTimeout(restoreOpenDrawer, 50);
        setTimeout(restoreOpenDrawer, 300);
      }

      return new Response(JSON.stringify(next), {
        status: response.status,
        statusText: response.statusText,
        headers: { 'Content-Type': 'application/json' }
      });
    });
  };

  document.addEventListener('click', async function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var removeBtn = target.closest(REMOVE_SELECTOR);
    if (!removeBtn) return;

    var drawer = removeBtn.closest('cart-drawer, #cart-drawer, [data-section-type="cart-drawer"]');
    if (!drawer) return;

    event.preventDefault();
    event.stopPropagation();

    if (removing || removeBtn.getAttribute('aria-disabled') === 'true') return;

    var itemRow = removeBtn.closest('[data-item], .cart__item, [data-cart-item]');
    var key = removeBtn.getAttribute('data-id') || removeBtn.dataset.key || (itemRow && itemRow.getAttribute('data-item'));
    var line = removeBtn.dataset.line || removeBtn.dataset.lineIndex || (itemRow && itemRow.getAttribute('data-item-index'));

    if (!key && !line) return;

    removing = true;
    var wasOpen = drawer.classList.contains('is-open');
    removeBtn.setAttribute('aria-disabled', 'true');
    if (itemRow) {
      itemRow.classList.add('is-removed');
      itemRow.style.opacity = '0.5';
    }

    var bodyPayload = key ? { id: key, quantity: 0 } : { line: Number(line), quantity: 0 };

    try {
      var response = await fetch(cartChangeUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(bodyPayload)
      });
      var cart = await response.json();

      if (!response.ok || cart.status || cart.errors) {
        throw new Error(cart.description || cart.message || cart.errors || 'Cart change failed');
      }

      refreshDrawer(drawer, cart);
      if (wasOpen) {
        keepDrawerOpen(drawer);
        requestAnimationFrame(function () {
          keepDrawerOpen(drawer);
        });
        setTimeout(restoreOpenDrawer, 50);
        setTimeout(restoreOpenDrawer, 300);
      }
    } catch (err) {
      console.error('Ошибка при удалении товара из корзины:', err);
      if (itemRow) {
        itemRow.classList.remove('is-removed');
        itemRow.style.opacity = '1';
      }
      removeBtn.removeAttribute('aria-disabled');
    } finally {
      removing = false;
    }
  }, true);
})();
